import React, { Component } from 'react';
import quickbook from '../../../../Assets/images/quickbook.png';
// import stripe from '../../../../Assets/images/stripe.png';
import optimoroute from '../../../../Assets/images/optimoroute.png';
import pulsem from '../../../../Assets/images/pulsem.png';
import { Select, Modal } from "antd";
import {isEmpty, map} from 'lodash';
import * as yup from 'yup';
import step_1 from '../../../../Assets/images/step_1.png';
import step_2 from '../../../../Assets/images/step_2.png';
import step_3 from '../../../../Assets/images/step_3.png';
import step_4 from '../../../../Assets/images/step_4.png';
import step_5 from '../../../../Assets/images/step_5.png';
import Loader from '../../../Common/Component/Loader';
import stax from "../../../../Assets/images/stax.png";
import { errorHandle } from "../../../Common/errorHandle";



const { Option } = Select;
class SetupOptions extends Component {

  state = {
    stripe_account_id: null,
    isDisabledSetupQuickbook: false,
    optimoroute_api_key:'',
    optimoroute_api_key_value: this.props.franchise_data.optimoroute_api_key ? this.props.franchise_data.optimoroute_api_key : '',
    isOptimorouteConnected: this.props.franchise_data.optimoroute_api_key ? true : false,
    errors: {},
    is_quickbooks_modal: false,
    quickbooks_client_id: '',
    quickbooks_client_secret: '',
    quickbooks_environment: '',
    stax_public_apikey : '',
    stax_bearer_apikey : '',
    is_show_stax_fields : false,
    stax_keys : {},
    pulsem_token : '',
    pulsem_location_id : '',
    is_show_pulsem_fields : false,
    pulsem_keys : {},
    loader : false
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    //Update Franchise
    if (Object.keys(props.StripeLogin.data).length > 0 && props.StripeLogin.data !== this.props.StripeLogin.data) {
      window.open(props.StripeLogin.data?.url, '_blank');
    }

    if (Object.keys(props.StripeLogin.errors).length > 0 && props.StripeLogin.errors !== this.props.StripeLogin.errors) {
      this.setState({
        loader: false,
      })
    }

    //Optimoroute Connection
    if (Object.keys(props.OptimorouteKey.data).length > 0 && props.OptimorouteKey.data.optimoroute_api_key !== this.props.OptimorouteKey.data.optimoroute_api_key) {
      this.setState({
        optimoroute_api_key: props.OptimorouteKey.data.optimoroute_api_key,
        isOptimorouteConnected: true
      })
          
    }
    
    if (Object.keys(props.OptimorouteKey.errors).length > 0 && props.OptimorouteKey.errors !== this.props.OptimorouteKey.errors) {
      this.setState({
        loader: false,
        optimoroute_api_key:''
      })
    }

    //Stax Connection
    if(Object.keys(props?.StaxKeys?.data).length > 0 && props.StaxKeys.data !== this.props.StaxKeys.data) {
      this.setState({
        stax_keys : props?.StaxKeys?.data,
        stax_public_apikey : props?.StaxKeys?.data?.stax_public_apikey,
        stax_bearer_apikey : props?.StaxKeys?.data?.stax_bearer_apikey,
        loader : false
      })
    }

    if(Object.keys(props?.StaxKeys?.errors).length > 0 && props.StaxKeys.errors !== this.props.StaxKeys.errors) {
      this.setState({
        loader : false
      })
    }

    //update Stax Keys
    if(Object.keys(props?.UpdateStaxKeys?.data).length > 0 && props.UpdateStaxKeys.data !== this.props.UpdateStaxKeys.data) {
      this.setState({
        is_show_stax_fields : false,
        loader : false
      })
    }

    if(Object.keys(props?.UpdateStaxKeys?.errors).length > 0 && props.UpdateStaxKeys.errors !== this.props.UpdateStaxKeys.errors) {
      this.setState({
        loader : false
      })
      errorHandle(props?.UpdateStaxKeys?.errors)
    }

    //PulseM Connection
    if(Object.keys(props?.PulseMKeys?.data).length > 0 && props.PulseMKeys.data !== this.props.PulseMKeys.data) {
      this.setState({
        pulsem_keys : props?.PulseMKeys?.data,
        pulsem_token : props?.PulseMKeys?.data?.pulsem_token,
        pulsem_location_id : props?.PulseMKeys?.data?.pulsem_location_id,
        loader : false
      })
    }

    if(Object.keys(props?.PulseMKeys?.errors).length > 0 && props.PulseMKeys.errors !== this.props.PulseMKeys.errors) {
      this.setState({
        loader : false
      })
    }

    if(Object.keys(props?.UpdatePulseMKeys?.data).length > 0 && props.UpdatePulseMKeys.data !== this.props.UpdatePulseMKeys.data) {
      this.setState({
        is_show_pulsem_fields : false,
        loader : false
      })
    }

    if(Object.keys(props?.UpdatePulseMKeys?.errors).length > 0 && props.UpdatePulseMKeys.errors !== this.props.UpdatePulseMKeys.errors) {
      this.setState({
        loader : false
      })
      errorHandle(props?.UpdatePulseMKeys?.errors)
    }

    // Quick book login
    if (Object.keys(props?.QuickbookLogin?.loginData).length > 0 && props?.QuickbookLogin?.loginData !== this.props?.QuickbookLogin?.loginData) {
      window.open(props?.QuickbookLogin?.loginData?.url, '_blank');
    }

    if (Object.keys(props?.QuickbookLogin?.errors).length > 0 && props?.QuickbookLogin?.errors !== this.props?.QuickbookLogin?.errors) {
      this.setState({
        loader: false,
        isDisabledSetupQuickbook: props?.QuickbookLogin?.errors?.status === 400 || false
      })
    }

  }

  componentDidMount = () => {

    if(this.props?.franchise_data?.stax_public_apikey === null || this.props?.franchise_data?.stax_public_apikey === '') {
      this.setState({
        is_show_stax_fields : true
      })
    }
    if(this.props?.franchise_data?.pulsem_token === null || this.props?.franchise_data?.stax_public_apikey === '') {
      this.setState({
        is_show_pulsem_fields : true
      })
    }
    if (this.props?.franchise_data) {
      this.props.getOptimorouteKey(this.props?.franchise_data.uuid);
      // this.props.getStaxKeys(this.props?.franchise_data.uuid)
      this.setState({
        stripe_account_id: this.props?.franchise_data?.stripe_account_id ? this.props?.franchise_data?.stripe_account_id : '',
        stax_public_apikey : this.props?.franchise_data?.stax_public_apikey ? this.props?.franchise_data?.stax_public_apikey : '',
        pulsem_token : this.props?.franchise_data?.pulsem_token ? this.props?.franchise_data?.pulsem_token : '' ,
        pulsem_location_id : this.props?.franchise_data?.pulsem_location_id ? this.props?.franchise_data?.pulsem_location_id : '',
      })
    }
    const franchiseData = JSON.parse(localStorage.getItem('temp_franchise'))
    if (franchiseData.data.optimoroute_api_key) {
      this.setState({
        isOptimorouteConnected: franchiseData.data.optimoroute_api_key ? true : false,
      })
    }

    if (this.props.franchise_data) {
      this.setState({isDisabledSetupQuickbook: this.props.franchise_data.is_quickbooks_connected})
    }
    console.log("Props : ",this.props);

  }

  // on quick book setup click
  // onSetupClick = () => {
  //   const franchise_data = JSON.parse(localStorage.getItem('temp_franchise'))
  //   if (!isEmpty(franchise_data?.data)) {
  //     this.props.loginWithQuickbook(franchise_data?.data?.uuid)
  //   }
  //   this.setState({ is_quickbooks_modal: false });
  // }

  onPulseMReconnectClick = async () => {
    await this.setState({
      loader : true
    })
    this.props.getPulseMKeys(this.props?.franchise_data.uuid);
    this.setState({
      is_show_pulsem_fields : true
    });
  }

  onConnectWithPulseM = (e) => {
    e.preventDefault();
    let { pulsem_token, pulsem_location_id } = this.state;
    let self = this;
    const schema = yup.object().shape({
      pulsem_token : yup.string().nullable().required("Authorization Access Token is required"),
      pulsem_location_id : yup.string().nullable().required("Location ID is required")
    });
    const data = {
      pulsem_token : pulsem_token, pulsem_location_id : pulsem_location_id
    };
    let err_data = {};
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ loader: true })
      this.setState({ errors: {} })
      this.props.updatePulseMKeys(data, this.props?.franchise_data.uuid)
      this.props.updateFranchiseData({...this.props.franchise_data, pulsem_token: this.state.pulsem_token })
    }).catch(function (err) {
      map(err.inner, (item) => {
        err_data[item.path] = item.message;
      })
      self.setState({
        errors: err_data
      })
    });
  }

  onReconnectClick = async () => {
    await this.setState({
      loader : true
    })
    this.props.getStaxKeys(this.props?.franchise_data.uuid);
    this.setState({
      is_show_stax_fields : true
    });
  }

  onConnectWithStax = (e) => {
    e.preventDefault();
    let { stax_public_apikey, stax_bearer_apikey } = this.state;
    let self = this;
    const schema = yup.object().shape({
      stax_public_apikey : yup.string().nullable().required("Web Payments Token is required"),
      stax_bearer_apikey : yup.string().nullable().required("API Key is required")
    });
    const data = {
      stax_public_apikey : stax_public_apikey,stax_bearer_apikey : stax_bearer_apikey
    };
    let err_data = {};
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ loader: true })
      this.setState({ errors: {} })
      this.props.updateStaxKeys(data, this.props?.franchise_data.uuid)
      this.props.updateFranchiseData({...this.props.franchise_data, stax_public_apikey: this.state.stax_public_apikey })
    }).catch(function (err) {
      map(err.inner, (item) => {
        err_data[item.path] = item.message;
      })
      self.setState({
        errors: err_data
      })
    });
  }

  onSetupClick = (e) => {
    e.preventDefault();
    let self = this;
    setTimeout(() => {
      let { quickbooks_client_id, quickbooks_client_secret, quickbooks_environment } = this.state;
      const schema = yup.object().shape({
        quickbooks_client_id: yup.string().required("Client ID is required"),
        quickbooks_client_secret: yup.string().required("Client Secret is required"),
        quickbooks_environment: yup.string().required("Environment is required")
      })

      const data = {
        quickbooks_client_id, quickbooks_client_secret, quickbooks_environment
      }

      // check validity
      let IsValid;
      let err_data = {};
      schema.isValid(data)
        .then(function (valid) {
          IsValid = valid
        });
      setTimeout(() => {
        if (IsValid) {
          //Call API For quickbooks 
          const franchise_data = JSON.parse(localStorage.getItem('temp_franchise'))
          if (!isEmpty(franchise_data?.data)) {
            self.props.loginWithQuickbook(franchise_data?.data?.uuid, 
              {
                "client_id": quickbooks_client_id,
                "client_secret": quickbooks_client_secret,
                "environment":quickbooks_environment
              })
          }
          self.setState({ is_quickbooks_modal: false });
        }
        else {

          schema.validate(data, { abortEarly: false })
            .catch(function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;
              })
              self.setState({
                errors: err_data
              })
              console.log("err_data:", err_data)
            });
        }
      }, 100);
    }, 300);
  }

  onSelectChange = (e) => {
    this.setState({
      quickbooks_environment: e
    })
  }


  onOptimorouteClick = () => {
    if(this.state.optimoroute_api_key_value.length> 0) {
      localStorage.removeItem('temp_franchise')
      this.setState({
        isOptimorouteConnected: true,
        optimoroute_api_key: this.state.optimoroute_api_key_value
      })
      this.props.updateOptimorouteKey({
        uuid: this.props?.franchise_data?.uuid,
        optimoroute_api_key: this.state.optimoroute_api_key_value
      })

      this.props.updateFranchiseData({...this.props.franchise_data, optimoroute_api_key: this.state.optimoroute_api_key_value })

    } else {
      this.setState({errors:{'optimoroute_api_key':'Please enter a valid API key.'}})
    }
  }
  render() {
    let { 
      isDisabledSetupQuickbook, is_quickbooks_modal, errors, stax_public_apikey, loader, is_show_stax_fields,
      pulsem_token, is_show_pulsem_fields
    } = this.state;

    return (
      <div className="setup_option_wrapper">
        <div className="left_side">
          <div className="card">
            <div className="card-body">
              <img src={quickbook} alt="" className="stripe_logo" />
              <p>Creating an app generates your development keys.
                            Use the app for yourself, your clients, or make it available to all QuickBooks users by listing it on the QuickBooks app store.</p>

              <ul className="quickbook_list">
                <li>Sign into the developer portal. From the menu at the top-right select <b>My Apps</b>. <u onClick={()=> window.open(step_1, "_blank")}>View Screenshot</u></li>
                <li>In the My Apps Dashboard create a new app by clicking the <b>+ Create an App button.</b> <u onClick={()=> window.open(step_2, "_blank")} >View Screenshot</u></li>
                <li>Select <b>QuickBooks Online and Payments.</b> <u>View Screenshot</u></li>
                <li>Enter a name for your app, select the Accounting scope and select the countries you want to accept connectionsfrom, and click on <b>Create App.</b> <u onClick={()=> window.open(step_3, "_blank")}>View Screenshot</u></li>
                <li>Development and Production keys can be found in the sidebar on the left. Under <b>Production</b> select<b> Keys and OAuth.</b> <u onClick={()=> window.open(step_4, "_blank")}>View Screenshot</u></li>
                <li>Locate your <b>Client ID </b>and <b>Client Secret.</b> <u onClick={()=> window.open(step_5, "_blank")}>View Screenshot</u></li>
                <li>Copy and paste <b>https://crm.doodycalls.com/franchise/detail</b> into the Link field under Redirect URIs and click Save at the bottom of the screen</li>

              </ul>
              <p> You need your <b>Client ID</b> and <b>Client Secret</b> in the next step to generate an OAuth 2.0 access token.</p>

              <button className={`btn ${isDisabledSetupQuickbook ? 'disabled' : 'btn-primary'}`} disabled={isDisabledSetupQuickbook} onClick={() => { this.setState({ is_quickbooks_modal: true})}}>{isDisabledSetupQuickbook ? 'Quickbook is already connected' : 'Setup Quickbooks'}</button>
            </div>
          </div>
        </div>
        <div className="right_side">
          <div className="card mb-20 stripe_Card">
            <div className="card-body">
              {/* <img src={stripe} alt="" className="stripe_logo" /> */}
              <img src={stax} alt="" className="stripe_logo" />
              <p> Your API keys are available in the StaxPay Fattmerchant Dashboard. They include randomly generated Web Payments Token and API Key. Sign-in to StaxPay Fattmerchant site and follow these steps Go to <b>{`Apps > Search API Keys > click Launch`}</b> and API keys code will be visible on site. Update/Replace these API keys here.</p>
              <p> If you don’t have an account then you can access link <b><a href="https://fattmerchant.com/home/sign-up/" target="_blank" rel="noopener noreferrer">SIGN UP</a></b> . Once you update required information, fill-up form details and follow the process as Stax site guides you. Once sign up process complete your account will be created successfully. Repeat above steps to update API Keys. Still, if you face any issue contact DoodyCalls support team.</p>
              {/* <div className="form-group">
                {
                  stripe_account_id ?

                    <button className="btn btn-warning">Stripe is connected already</button>
                    :
                    <button
                      onClick={() => {
                        this.props.loginWithStripe(this.props?.franchise_data?.uuid);
                        localStorage.setItem('is_stripe_connect', JSON.stringify({ is_stripe_connect: true }));
                      }}
                      className="btn btn-primary">Login with stripe </button>
                }
              </div> */}
              <div className="form-group">
                {
                  this.state.is_show_stax_fields ?
                    <>
                      <div className="fitem">
                        <label className="error-color">Web Payments Token </label>
                        <input type="text" placeholder="Web Payments Token" value={this.state.stax_public_apikey} onChange={(e) => {
                          this.setState({
                            stax_public_apikey: e.target.value
                          })
                        }} />
                        {this.state.errors['stax_public_apikey'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{this.state.errors['stax_public_apikey']}</label> : ''}
                      </div>
                      <div className="fitem">
                        <label className="error-color">API Key </label>
                        <input type="text" placeholder="API Key" value={this.state.stax_bearer_apikey} onChange={(e) => {
                          this.setState({
                            stax_bearer_apikey : e.target.value
                          })
                        }} />
                        {this.state.errors['stax_bearer_apikey'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{this.state.errors['stax_bearer_apikey']}</label> : ''}
                      </div>
                    </>
                    : ''
                }
              </div>
              <div className="form-group">
                {
                  stax_public_apikey && !is_show_stax_fields ?
                    <button className="btn btn-warning">Stax is connected already</button>
                    :
                    <button className="btn btn-primary" onClick={this.onConnectWithStax}> Save </button>
                }
                {!is_show_stax_fields ? <button className="btn btn-primary" onClick={this.onReconnectClick}>Reconnect</button> : '' }
              </div>
            </div>
          </div>
          <div className="card mb-20 stripe_Card">
            <div className="card-body">
              <img src={optimoroute} alt="" className="stripe_logo" />

              <p>To enable the API and generate the API key please log into the OptimoRoute web application. In the Administration section select <b> Settings &gt; WS API</b> and enable the API. The API key will be generated for you.</p>

              <div className="form-group">
                {this.state.isOptimorouteConnected ? 
                  <React.Fragment>
                    <button className="btn btn-warning">Optimoroute is already connected</button>
                    <button className="btn btn-primary" onClick={() => {
                      this.setState({
                        isOptimorouteConnected: false,
                        optimoroute_api_key: ''
                      })
                    }}>Reconnect</button>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <div className="fitem">
                      <label className="error-color">OptimoRoute API Key </label>
                      <input 
                        type="text" 
                        placeholder="Your secret token"
                        value={this.state.optimoroute_api_key_value}
                        onChange={(e) => this.setState({
                          optimoroute_api_key_value: e.target.value
                        })} />
                   
                      {this.state.errors['optimoroute_api_key'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{this.state.errors['optimoroute_api_key']}</label> : ''}
                    </div>
                    <button className="btn btn-primary" onClick={() => this.onOptimorouteClick()}>Save Optimoroute API </button> </React.Fragment> }
              </div>
            </div>
          </div>
          <div className="card mb-20 stripe_Card">
            <div className="card-body">
              <img src={pulsem} alt="" className="stripe_logo" />
              <p>To enable the API and generate the API key </p>
              <ul className="quickbook_list">
                <li>Contact <b>support@pulsem.me</b> to request your API access.</li>
                <li>You will be provided with your <b>PulseM API key</b> and <b>Location ID</b> information.</li>
                <li>Once received, please add the keys to their input fields and select Save PulseM API.</li>
              </ul>

              <div className="form-group">
                {
                  this.state.is_show_pulsem_fields ?
                    <>
                      <div className="fitem">
                        <label className="error-color">Authorization Access Token </label>
                        <input type="text" placeholder="Your Authorization Access Token" value={this.state.pulsem_token} onChange={(e) => {
                          this.setState({
                            pulsem_token: e.target.value
                          })
                        }} />
                        {this.state.errors['pulsem_token'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{this.state.errors['pulsem_token']}</label> : ''}
                      </div>
                      <div className="fitem">
                        <label className="error-color">Location ID </label>
                        <input type="text" placeholder="Your Location ID" value={this.state.pulsem_location_id} onChange={(e) => {
                          this.setState({
                            pulsem_location_id : e.target.value
                          })
                        }} />
                        {this.state.errors['pulsem_location_id'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{this.state.errors['pulsem_location_id']}</label> : ''}
                      </div>
                    </>
                    : ''
                }
              </div>
              <div className="form-group">
                {
                  pulsem_token && !is_show_pulsem_fields ?
                    <button className="btn btn-warning">PulseM Is Already Connected</button>
                    :
                    <button className="btn btn-primary" onClick={this.onConnectWithPulseM}>Save PulseM API</button>
                }
                {!is_show_pulsem_fields ? <button className="btn btn-primary" onClick={this.onPulseMReconnectClick}>Reconnect</button> : '' }
              </div>
            </div>
          </div>
        </div>
        <Modal
          visible={is_quickbooks_modal}
          okText={"Connect"}
          cancelText={"Cancel"}
          onOk={
            (e) => this.onSetupClick(e)  
          }
          onCancel={() => {
            this.setState({ is_quickbooks_modal: false });
          }}
          className="delete_user_modal"
          width={532}
        >
          <div className="p15">
            <h4>
              Quickbooks Connect
            </h4>
            <div className="form-group">
              <div className="fitem">
                <div className="fitem">
                  <label>Client ID</label>
                  <input
                    type="text"
                    name="city"
                    autoComplete="franchise_city"
                    onChange={(e) => { this.setState({
                      quickbooks_client_id: e.target.value
                    })  }}
                    placeholder="Client ID" />
                  {errors['quickbooks_client_secret'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['quickbooks_client_secret']}</label> : ''}

                </div>
              </div>
              <div className="fitem">
                <div className="fitem">
                  <label>Client Secret</label>
                  <input
                    type="text"
                    name="city"
                    autoComplete="franchise_city"
                    onChange={(e) => { this.setState({
                      quickbooks_client_secret: e.target.value
                    }) 
                    }}
                    placeholder="Client Secret" />
                  {errors['quickbooks_client_secret'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['quickbooks_client_secret']}</label> : ''}

                </div>

              </div>
              <div className="fitem">
                <div className="fitem">
                  <label>Environment</label>
                  <Select
                    name="quickbooks_environment"
                    value={this.state.quickbooks_environment || undefined}
                    onChange={(e) => { this.onSelectChange(e) }}
                    placeholder="Environment"
                    defaultValue='Select Environment'
                  >
                    <Option value="sandbox">Sandbox</Option>
                    <Option value="production">Production</Option>
                  </Select>
                  {errors['quickbooks_environment'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['quickbooks_environment']}</label> : ''}

                </div>
                
              </div>
            </div>
          </div>
        </Modal>
        {
          loader ?
            <Loader />
            : ''}
      </div >
    );
  }
}

export default SetupOptions;